import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class AssignedProjectService {
    constructor(http) {
        this.http = http;
        this.singular = 'assigned project';
        this.plural = 'assigned projects';
        this.editor = PLATFORM.moduleName('pages/daiatari/assigned-projects/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`assigned-projects/filter/${loadOptions}`);
        return await response.json();
    }

    async create(assignedProject) {
        await this.http.fetch('assigned-projects', { method: 'POST', body: json(assignedProject) });
    }

    async update(assignedProject) {
        await this.http.fetch(`assigned-projects/${assignedProject.id}`, { method: 'PUT', body: json(assignedProject) });
    }

    async delete(id) {
        await this.http.fetch(`assigned-projects/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`assigned-projects/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`assigned-projects/top-three/${query}`);
        return await response.json();
    }
}